import { Component } from '@angular/core';

@Component({
  selector: 'ocf-failing-validation-notice',
  template: ` <ocf-alert type="warning" i18n> Form is invalid and cannot be submitted. Please check the required fields. </ocf-alert> `,
  standalone: false,
})
export class OcfFailingValidationNoticeComponent {}
